import {
  Field,
  Form,
  ModalContainer,
  ModalLayoutCenter,
} from "@kanda-libs/ks-component-ts";
import { Button, Loader } from "@kanda-libs/ks-design-library";
import type { FunctionComponent, MutableRefObject } from "react";
import { MODAL_COPY, MODAL_ID } from "components/job/JobRevertModal/constants";
import useJobRevertModalProps from "components/job/JobRevertModal/useJobRevertModalProps";

const JobRevertModal: FunctionComponent = function () {
  const {
    form,
    areYouSure,
    onAreYouSure,
    onClose,
    onSubmit,
    disabled,
    isSubmitting,
  } = useJobRevertModalProps();

  return (
    <ModalContainer id={MODAL_ID} opacity={30}>
      {({ handleClose, ref }) => (
        <>
          <ModalLayoutCenter
            id="staff-revert-job-modal"
            onClose={() => {
              onClose();
              handleClose();
            }}
            ref={ref as MutableRefObject<HTMLDivElement>}
            className="w-10/12 md:w-160"
          >
            <>
              {!areYouSure && (
                <div className="flex flex-col">
                  <span className="mb-6 text-16-20-em">Revert this job</span>
                  <span className="mb-4">
                    Are you sure you want to revert this job?
                  </span>
                  <Button.Text
                    id="staff-revert-job-are-you-sure"
                    label="Continue"
                    onClick={onAreYouSure}
                  />
                </div>
              )}
              {areYouSure && (
                <Form id="staff-job-revert" form={form} onSubmit={onSubmit}>
                  <div className="flex flex-col">
                    <span className="mb-6 text-16-20-em">Revert this job</span>
                    <span className="mb-4">{MODAL_COPY}</span>
                    <Field.Input name="safety" />
                    <Button.Text
                      id="staff-revert-job-submit"
                      disabled={disabled || isSubmitting}
                      label="Confirm"
                      onClick={onSubmit}
                    />
                  </div>
                  <Loader isLoading={isSubmitting} />
                </Form>
              )}
            </>
          </ModalLayoutCenter>
        </>
      )}
    </ModalContainer>
  );
};

export default JobRevertModal;
